<app-base-modal
  [title]="'Файлы книги гипотез'"
  [showStateToggle]="true"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="container">
    @for (column of hypothesisModalColumn; track $index) {
      <div class="item">
        <div class="item-title">{{ column.title }}</div>
        <div class="item-content">
          @if (hypothesisFilesStateService.hypothesisFilesState()?.[column.fileType]?.length) {
            <div class="item-content-files">
              @for (hypothesisData of hypothesisFilesStateService.hypothesisFilesState()?.[column.fileType]; track $index) {
                <app-file-card
                  [fileCard]="{
                    id: hypothesisData.id,
                    fileParams: hypothesisData.file,
                    fileType: column.fileType,
                    isEditModeActive: this.isEditModeActive,
                    shouldCheckImageType: true
                  }"
                  [isNeedArrow]="previewFileUrlsStateService.previewFileUrlsState()[column.fileType].length > 1"
                  [isNeedPreview]="true"
                  (handleDelete)="handleDelete($event, hypothesisData)"
                />
              }
            </div>
          } @else {
            <div class="item-content-no-files">
              Нет файлов
            </div>
          }
        </div>
        <app-file-upload-card
          [fileUploadParams]="{
            parentId: hypothesisDialogData.id,
            recordId: hypothesisDialogData.id,
            type: column.fileType,
            entityFileType: 'HYPOTHESIS'
          }"
          [isEditModeActive]="isEditModeActive"
          [isNeedPreview]="true"
          (attachFile)="attachFile($event)"
        />
        <div class="comment">
          <mat-form-field
            appearance="outline"
            class="item-form-field"
            [class]="setFieldClasses()"
            [matTooltip]="getTooltip(column.inputName)"
            [matTooltipPosition]="'above'"
            matTooltipClass="multiline-tooltip"
            [matTooltipDisabled]="isEditModeActive"
          >
            <mat-label>Комментарий</mat-label>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="4"
              cdkAutosizeMaxRows="4"
              type="text"
              [(ngModel)]="hypothesisDialogData[column.inputName]"
              (blur)="handleValueChange(column.inputName)"
            ></textarea>
          </mat-form-field>
          <button
            mat-mini-fab
            class="fullscreen-text"
            (click)="handleOpenFullscreenText(column)"
          >
            <mat-icon class="fullscreen-text-icon">fullscreen</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</app-base-modal>
